const pricingEnabledUsers = [
  { username: "javiergrijalba" },
  { username: "guest" },
  { username: "dianavillalba" },
  { username: "vanesausuga" },
  { username: "mauricioarango" },
  { username: "LauraC" },
  { username: "AnaVentura" },
  { username: "Santiago Guapacha" }
];

module.exports = {
  pricingEnabledUsers
};
